import Simplemodal from '../../plugins/simplemodal.js';
import isMobile from '../../plugins/is-mobile.js';

const fullScreenMenu = new Simplemodal({
  trigger: "data-fullScreenMenu-trigger",
  clickOutSideClose: true
})

if (isMobile(768)) {
  $('.-title-option').click(function () {
    if (!($(this).parent().parent().hasClass('is-open-title'))) {
      $(this).parent().parent().addClass('is-open-title');
    } else {
      $(this).parent().parent().removeClass('is-open-title');
      $(this).parent().parent().removeClass('is-open-subtitle');
    }
  });

  $('.-subtitle-option').click(function () {
    if (!($(this).parent().parent().hasClass('is-open-subtitle'))) {
      $(this).parent().parent().addClass('is-open-subtitle');
    } else {
      $(this).parent().parent().removeClass('is-open-subtitle');
    }
  });
}
